import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { keys } from "../queryKeys.js";
import * as api from "../api/routingRules.js";

export function useRoutingRules(options = {}) {
  return useQuery({
    queryKey: keys.routingRules.list,
    queryFn: api.fetchRoutingRules,
    ...options,
  });
}

export function useCreateRoutingRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.createRoutingRule,
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.routingRules.all }),
  });
}

export function useUpdateRoutingRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => api.updateRoutingRule(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.routingRules.all }),
  });
}

export function useDeleteRoutingRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.deleteRoutingRule,
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.routingRules.all }),
  });
}

export function usePreviewRoutingRules() {
  return useMutation({ mutationFn: api.previewRoutingRules });
}
